/**
 * 조명제어기 등록(BLE/WiFi) 성공 시 마지막 WiFi 자격증명 로컬 저장.
 * 앱 재시작 후에도 유지 (localStorage).
 */
const STORAGE_KEY = 'inshow.lastSuccessfulWifi';

export function loadSavedWifiCredentials() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return { ssid: '', password: '' };
    }
    const parsed = JSON.parse(raw);
    return {
      ssid: typeof parsed?.ssid === 'string' ? parsed.ssid : '',
      password: typeof parsed?.password === 'string' ? parsed.password : '',
    };
  } catch {
    return { ssid: '', password: '' };
  }
}

export function saveWifiCredentials(ssid, password) {
  const nextSsid = typeof ssid === 'string' ? ssid.trim() : '';
  const nextPassword = typeof password === 'string' ? password : '';
  if (!nextSsid || !nextPassword) {
    return;
  }
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ ssid: nextSsid, password: nextPassword }),
    );
  } catch {
    // quota / private mode 등 — 무시
  }
}
